import { render, staticRenderFns } from "./MarriageEnergyOne.vue?vue&type=template&id=2ffcbccc&"
import script from "./MarriageEnergyOne.vue?vue&type=script&lang=js&"
export * from "./MarriageEnergyOne.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports